import React, { Fragment } from "react";

/**
 * [Space 间隔]
 * @param children
 * @param {'small'|'default'|'large'} size
 * @param rest
 * @constructor
 */
export const Space = ({ children, size = "default", ...rest }) => {
  const margin = {
    small: "5px",
    default: "10px",
    large: "20px",
  };

  const childrenWithSpace = React.Children.map(children, (child, index) => (
    <Fragment key={index}>
      {child}
      {index < children.length - 1 && (
        <span style={{ marginRight: margin[size] }} />
      )}
    </Fragment>
  ));

  return (
    <div className="space-container" {...rest}>
      {childrenWithSpace}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Space/index.js